import React from 'react'
import jsPDF from "jspdf";
import { useCurrencySymbol } from '../../../../../utils/currencyUtils';
import CommaConvert from '../../../../../utils/CommaConvert';

const OPShowTaskListPM = ({ showListState,
    matchedRowWorkEntries,
    matchedRowDesctiption,
    matchedRowHardwareParts,
    row
}) => {
    const currency = useCurrencySymbol();
    const USAComma = CommaConvert();

    const downloadPDFHardware = (newHardwareParts) => {
        const doc = new jsPDF();
        doc.autoTable({
            head: [
                [
                    "Sr. No",
                    "Part Name",
                    "Part Number",
                    "Quantity",
                    `Unit Price (${currency})`,
                    `Total Price (${currency})`,
                ],
            ],
            body: newHardwareParts.map((LeadReport, index) => [
                index + 1,
                LeadReport.assemblepartdescription,
                LeadReport.partno,
                LeadReport.quantity,
                USAComma(LeadReport.unitprice),
                USAComma(LeadReport.totalprice),
            ]),
            styles: {
                fontSize: 7,
            },
            headStyles: {
                fontSize: 8,
            },
        });
        doc.save("Hardware PartList.pdf");
    };

    const downloadPDFHardwareDescriptions = (newDescriptions) => {
        const doc = new jsPDF();
        doc.autoTable({
            head: [["Sr. No", "Description", `Amount (${currency})`, "Notes"]],
            body: newDescriptions.map((LeadReport, index) => [
                index + 1,
                LeadReport.description,
                USAComma(LeadReport.value),
                LeadReport.notes,
            ]),
            styles: {
                fontSize: 7,
            },
            headStyles: {
                fontSize: 8,
            },
        });
        doc.save("Hardware OtherExpensesList.pdf");
    };
    return (
        <div className='group-hover:bg-gray-100'>
            {showListState === "tasktable" && (
                <div>
                    {row?.TypeService?.toLowerCase().includes("hardware") ? (
                        // {row?.TypeService === "Hardware" ? (
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            className="w-full rounded-lg h-full justify-center"
                        >
                            <div
                                className="w-full border border-gray-300 overflow-hidden">
                                <div className="grid grid-cols-3 bg-blue-500 text-white text-[11px]">
                                    <div className="p-1 border-r  text-center">
                                        Total Parts{" "}
                                    </div>
                                    <div className="p-1 border-r text-center">
                                        Total Price ({currency})
                                    </div>
                                    <div className="p-1 text-center">
                                        Action
                                    </div>
                                </div>

                                <div className="grid grid-cols-3 bg-white text-black text-[11px]">
                                    <div className="p-1 border-r border-blue-200 text-center">
                                        {matchedRowHardwareParts?.length}
                                    </div>
                                    <div className="p-1 border-r border-blue-200 text-center">
                                        {currency}
                                        {USAComma(
                                            matchedRowHardwareParts?.reduce(
                                                (sum, item) => {
                                                    return (
                                                        sum + (item.totalprice || 0)
                                                    );
                                                },
                                                0
                                            )
                                        )}{" "}
                                    </div>
                                    <div
                                        title="Download Hardware Part List"
                                        className="p-1 text-center cursor-pointer hover:bg-blue-50"
                                        onClick={() =>
                                            downloadPDFHardware(
                                                matchedRowHardwareParts
                                            )
                                        }
                                    >
                                        Download
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="w-full flex gap-2">
                            <div className="w-full max-h-[14rem] overflow-auto">
                                <div className="flex text-center text-[11px] sticky top-0 z-10 bg-[#1973eb] text-white">
                                    <div className="w-[40%] border p-1">Task</div>
                                    <div className="w-[30%] border p-1">Hrs</div>
                                    <div className="w-[30%] border p-1">
                                        Notes
                                    </div>
                                </div>
                                <div className="flex text-center text-[11px] font-semibold bg-gray-100">
                                    <div className="w-[40%] border p-1">
                                        Total
                                    </div>
                                    <div className="w-[30%] border p-1">
                                        {USAComma(
                                            Array.isArray(matchedRowWorkEntries)
                                                ? matchedRowWorkEntries?.reduce(
                                                    (sum, item) => sum + (item.hoursassigned || 0),
                                                    0
                                                )
                                                : 0
                                        )}

                                    </div>
                                    <div className="w-[30%] border p-1"></div>
                                </div>
                                {matchedRowWorkEntries?.map((entry, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className="flex text-center text-[11px]"
                                        >
                                            <div
                                                className="w-[40%] border p-1"
                                            >
                                                {entry.task}
                                            </div>
                                            <div
                                                className="w-[30%] border p-1"
                                            >
                                                {entry.hoursassigned}
                                            </div>
                                            <div
                                                className="w-[30%] border p-1"
                                            >
                                                {entry.notes}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                </div>
            )}


            {showListState === "otherexpenses" && (
                <>
                    {row?.TypeService?.toLowerCase().includes("hardware") ? (
                        // {row?.TypeService === "Hardware" ? (
                        <div
                            className="w-full border border-gray-300 overflow-hidden ">
                            <div className="grid grid-cols-3 bg-blue-500 text-white text-[11px]">
                                <div className="p-1 border-r  text-center">
                                    Total Descriptions{" "}
                                </div>
                                <div className="p-1 border-r text-center">
                                    Total Amount ({currency})
                                </div>
                                <div className="p-1 text-center">Action</div>
                            </div>

                            <div className="grid grid-cols-3 bg-white text-black text-[11px]">
                                <div className="p-1 border-r border-blue-200 text-center">
                                    {matchedRowDesctiption?.length}
                                </div>
                                <div className="p-1 border-r border-blue-200 text-center">
                                    {currency}
                                    {USAComma(
                                        matchedRowDesctiption?.reduce(
                                            (sum, item) => {
                                                return sum + (item.value || 0);
                                            },
                                            0
                                        )
                                    )}{" "}
                                </div>
                                <div
                                    title="Download Description List"
                                    className="p-1 text-center cursor-pointer hover:bg-blue-50"
                                    onClick={() =>
                                        downloadPDFHardwareDescriptions(
                                            matchedRowDesctiption
                                        )
                                    }
                                >
                                    Download
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="w-full flex gap-2">
                            <div className="w-full max-h-[14rem] overflow-auto">
                                <div className="flex text-center text-[11px] sticky top-0 z-10">
                                    <div className="w-[40%] border p-1 bg-[#1973eb] text-white truncate">
                                        Description
                                    </div>
                                    <div className="w-[30%] border p-1 bg-[#1973eb] text-white">
                                        Amount ({currency})
                                    </div>
                                    <div className="w-[30%] border p-1 bg-[#1973eb] text-white">
                                        Notes
                                    </div>
                                </div>

                                <div className="flex text-center text-[11px] font-semibold bg-gray-100">
                                    <div className="w-[40%] border p-1 truncate">
                                        Total
                                    </div>
                                    <div className="w-[30%] border p-1">
                                        {currency}
                                        {USAComma(
                                            matchedRowDesctiption?.reduce(
                                                (sum, item) => {
                                                    return sum + (item.value || 0);
                                                },
                                                0
                                            )
                                        )}
                                    </div>
                                    <div className="w-[30%] border p-1"></div>
                                </div>

                                {matchedRowDesctiption?.map(
                                    (description, index) => {
                                        return (
                                            <div
                                                key={index}
                                                className="flex text-center text-[11px]"
                                            >
                                                <div
                                                    className="w-[40%] border p-1"
                                                >
                                                    {description.description}
                                                </div>
                                                <div
                                                    className="w-[30%] border p-1"
                                                >
                                                    {USAComma(description.value)}
                                                </div>
                                                <div
                                                    className="w-[30%] border p-1"

                                                >
                                                    {description.notes}
                                                </div>
                                            </div>
                                        );
                                    }
                                )}
                            </div>
                        </div>
                    )}

                </>

            )}
        </div>
    )
}

export default OPShowTaskListPM